module.exports = __webpack_public_path__ + "img/friends-drinking-eating-tailgate-party.6ed6518a.png";